import { Pipe, PipeTransform, Inject } from '@angular/core';
import { LOCALE_ID } from '@angular/core';
import dayjs from '@shared/date/dayjs-bootstrap';

@Pipe({
    name: 'relativeTime',
    pure: false,
    standalone: false
})
export class RelativeTimePipe implements PipeTransform {
  constructor(@Inject(LOCALE_ID) private locale: string) {
    dayjs.locale(this.locale);
  }

  transform(value: string | number | Date, suffix: boolean = false): string {
 
    return dayjs.tz(new Date(value)).fromNow(!suffix);
  }
}
